import { render, staticRenderFns } from "./ApplicationInfo.vue?vue&type=template&id=35e86c6e&scoped=true&"
import script from "./ApplicationInfo.vue?vue&type=script&lang=js&"
export * from "./ApplicationInfo.vue?vue&type=script&lang=js&"
import style0 from "./ApplicationInfo.vue?vue&type=style&index=0&id=35e86c6e&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "35e86c6e",
  null
  
)

export default component.exports